
import { Box, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { FC } from "react";
import { EmptyIcon } from "../EmptyIcon";

interface EmptyProperties {
    message: string;
}
const Empty: FC<EmptyProperties> = ({ message }) => {
    return (
        <Grid container size={12} style={{ justifyContent: "center", marginTop: 20 }}>
            <Box style={{ textAlign: 'center', padding: '25px 10px' }}>
                <EmptyIcon />

                <Typography
                    style={{
                        fontWeight: 'normal',
                        color: grey[400],
                        fontSize: 16
                    }}
                >
                    { message }
                </Typography>
            </Box>
        </Grid>
    )
}
export { Empty }